<template>
  <el-dialog
    :visible.sync="showMakeAppoint"
    width="560px"
    :before-close="close"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <div class="form">
      <img
        @click="close"
        class="close"
        src="../assets/img/com/close.png"
        alt=""
      />
<!--   2022年4月21日屏蔽交互    -->
<!--      <div class="title">预约演示</div>-->
      <span class="des">• 填写后工作人员将于1个工作日内与您取得联系</span>
      <span class="des">• 若您的需求非常迫切，可拨打028-95094050联系我们</span>

      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        label-position="top"
        :hide-required-asterisk="false"
      >
        <el-form-item
          label="您的姓名或称谓（必填）"
          prop="name"
          class="form-item"
        >
          <el-input
            v-model="ruleForm.name"
            placeholder="请输入姓名或称谓"
            :class="[ruleForm.name ? 'isValInput' : 'input']"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="企业名称（必填）"
          prop="firmName"
          class="form-item"
        >
          <el-input
            v-model="ruleForm.firmName"
            placeholder="请输入企业名称"
            :class="[ruleForm.firmName ? 'isValInput' : 'input']"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="联系电话（必填）"
          prop="telephone"
          class="form-item"
        >
          <el-input
            v-model.number="ruleForm.telephone"
            placeholder="请输入电话号码"
            maxlength="11"
            :class="[ruleForm.telephone ? 'isValInput' : 'input']"
          ></el-input>
        </el-form-item>

        <el-form-item label="您的职位" prop="jobs" class="form-item">
          <el-input
            v-model="ruleForm.jobs"
            placeholder="请输入职位名称"
            :class="[ruleForm.jobs ? 'isValInput' : 'input']"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button class="submit" @click="submitForm('ruleForm')"
            >立即预约</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { checkPhoneNumber } from "../util/public";
import { mapState } from "vuex";
export default {
  name: "MakeAppointForm",
  data() {
    return {
      ruleForm: {
        name: "",
        firmName: "",
        telephone: "",
        jobs: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名或称谓", trigger: "blur" },
        ],
        firmName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        telephone: [
          {
            required: true,
            trigger: "blur",
            validator: checkPhoneNumber,
          },
        ],
        jobs: [{ required: false, message: "请输入职位名称", trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapState(["showMakeAppoint"]),
  },
  methods: {
    close() {
      this.$refs["ruleForm"].resetFields();
      this.$store.commit("changeShowMakeAppoint", false);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.ruleForm);
          this.$axios({
            method: "post",
            url: this.APIurl.API.api.addOrderOperation,
            data: this.$qs.stringify({
              name: this.ruleForm.name,
              firmName: this.ruleForm.firmName,
              telephone: this.ruleForm.telephone,
              jobs: this.ruleForm.jobs,
            }),
          }).then((res) => {
            this.$message({
              showClose: true,
              message: "预约成功",
              type: "success",
            });
            this.close()
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  display: none;
}
.el-dialog__body {
  .form {
    width: 560px;
    padding: 43px 50px 33px 50px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    .close {
      width: 30px;
      position: absolute;
      top: 12px;
      right: 12px;
      cursor: pointer;
    }
    .title {
      font-size: 26px;
      font-weight: bold;
      color: #4f75c5;
      text-align: center;
      width: 100%;
      margin-bottom: 30px;
    }
    .des {
      font-size: 16px;
      font-weight: 400;
      color: #7d889f;
    }
    .demo-ruleForm {
      width: 100%;
      .form-item {
        margin-top: 20px;
        /deep/ .el-form-item__label {
          width: 100%;
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          line-height: 18px;
          padding: 0;
        }
        /deep/.input input {
          border-bottom: 1px solid #cbccd1;
        }
        /deep/ input {
          font-size: 16px;
          font-weight: 400;
          color: #999999;
          border-radius: 0;
          border: 0;
          padding: 0;
          display: flex;
          align-items: center;
        }
        /deep/ input:focus {
          border-bottom: 1px solid #4f75c5;
        }
        /deep/.isValInput input {
          border-bottom: 1px solid #333333;
        }
      }
      .submit {
        width: 100%;
        height: 56px;
        background: #ff9820;
        border-radius: 4px;
        font-size: 20px;
        font-weight: bold;
        color: #ffffff;
        border: 0;
        margin-top: 8px;
        transition: background-color 0.5s;
      }
      .submit:hover {
        background: #f18200;
      }
    }
  }
}

/deep/.el-dialog {
  border-radius: 10px;
  background-color: #fff;
}
/deep/.el-dialog__body {
  padding: 0;
}
/deep/ .el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}

@media all and (max-width: 768px) {
  /deep/ .el-form-item__label {
    font-size: 16px !important;
    line-height: 16px;
  }
  /deep/ input {
    font-size: 14px !important;
  }
  /deep/.el-dialog {
    width: 92% !important;
    .form {
      width: 100%;
      padding: 10px 20px 0px 20px;
      .title {
        font-size: 20px;
        margin-bottom: 20px;
      }
      .des {
        font-size: 12px;
      }
      .demo-ruleForm {
        margin-top: 10px;
        .form-item {
          margin-top: 0px;
        }
        .submit {
          width: 100%;
          height: 46px;
          font-size: 16px;
          margin-top: 8px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MakeAppointForm.vue